export const homeData = {
    
    "automobile" : {
        "isSubCategoryExist": false,
        "prod_cat_id" : "cat_d8R14zUNE",
        "product_sub_cat_id": "",
        "redirect_url" : "/category/cars/try",
        "hero_section" :{
            "heading" : "Create Professional Car Image That Builds Shopper Trust",
            "sub_heading" :"Drop your image and see how SpyneAI converts poor car images into studio-grade, premium images 100% automatically",
            "banner_images" : [`${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-hero.gif`]
        },
        "enterprises_section" : {
            "heading": "Trusted By The World's Fastest Growing Companies ",
            "sub-heading": "",
            "enterprises_list": [
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client1.png`, 
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client2.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client3.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client4.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client5.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client6.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-n-bike.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/karvi-client.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client9.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client10.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client11.png`
            ]
        },
        // Mobile App section 
        "app_section" : {
            "heading" : "Car Photography & Editing Made Simple & Scalable",
            "sub_heading" : "",
            "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/mobile-app.png`,
            "side_image": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-mobile1.gif`,
            "content" : [
                {
                    "content_heading" : "Shoot Like a Pro",
                    "content_subheading" : "Engage your visitors on your website with immersive visuals",
                    "accordion_item_on_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord1.png`,
                    "accordion_item_off_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord01.png`,
                    "content_description": [
                        {
                            "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                            "text": "Follow guided overlays to shoot the best car angles instantly",
                        },
                        {
                            "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                            "text": "Create 360° Walkarounds of your car in less than 3 minutes",
                        },
                      
                    ]
                },
                {
                    "content_heading" : "Edit Images — 100% Automatically",
                    "content_subheading" : "Use 500X faster transformative tech to edit your images in bulk",
                    "accordion_item_on_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord2.png`,
                    "accordion_item_off_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord02.png`,
                    "content_description": [
                        {
                            "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                            "text": "The App's AI edits your car images in seconds",
                        },
                        {
                            "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                            "text": "You can choose from 100s of premium backgrounds",
                        },
                       
                    ]
                },
                {
                    "content_heading" : "Publish Instantly",
                    "content_subheading" : "Publish your images to your dealership website faster than ever  ",
                    "accordion_item_on_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord3.png`,
                    "accordion_item_off_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord03.png`,
                    "content_description": [
                        {
                            "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                            "text": "Download and publish final images to your website instantly",
                        },
                        {
                            "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                            "text": "Decrease cataloging time by making your cars live 90% faster",
                        },
                        
                    ]
                },
            ]
        },
        "web_section" : {
            "heading" : "One Tap to Professional Car Images in Seconds",
            "sub_heading" : " ",
            "banner_heading" : "The Best Car Image Editing Tool Ever. 500x Fast And Effortless",
            "banner_sub_heading" : "Create professional & uniform car images that boost conversions by 40% using the power of Artificial Intelligence",
            "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/web-app.png`,
            "banner_image2" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/web-img.png`,
            "web_description" : [
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Effortlessly edit hundreds of images instantly          ",
                },
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Choose from 100s premium backgrounds",
                },
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Turn inconsistent catalogs to engaging & uniform catalogs in seconds",
                }
            ],
            "start_now_link": "https://spyne.ai/category/cars/try"
        },
        "api_section" : {
            "heading" : "Automate, Simplify & Scale Your Work   ",
            "sub_heading" : "",
            "banner_heading" : "Use Computer Vision & AI Tech to Bring Efficiency to Your Workflow  ",
            "banner_sub_heading" : "Effortlessly automate and streamline your workflow with our APIs and reduce week-long processes to a few minutes. ",
            "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/api.png`,
            "api_description" : [
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Transform your massive catalogs instantly ",
                },
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Save 90% of your time by automating repetitive tasks",
                },
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Minimize the operational costs significantly",
                }
            ],
            "start_now_link": "https://documenter.getpostman.com/view/10990096/TzRX7Qbq"
        },
        "dashboard_section" : {
            "heading" : "One Place To Manage & Measure Your Shoots",
            "sub_heading" : "",
            "banner_heading" : "",
            "banner_sub_heading" : "Single dashboard to track and manage all your shoots in real time and download to publish your images directly to your website.",
            "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/dashboard.png`,
            "api_description" : [
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Affordable way to create quality 360° Walkarounds in minute",
                },
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Make your videos live faster onto your website instantly",
                },
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Let your shoppers explore your vehicles & help them make informed decisions.",
                }
            ],
            "small_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/dash-middle.png`,
            "zoomInImages" : [
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/dash-middle.png', //Middle Image of dashboard
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-2.png',
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-3.png', 
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-4.png',
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-5.png',
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-6.png',
            ],
        },
        "templates" : {
            "heading" : "Premium Car Backgrounds to Stand Out",
            "sub_heading" : "Dealerships can choose a unique background from 100s of studio-grade templates ",
            "custom_images" :[
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg23.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg1.png`
                }, 
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg3.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg21.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg22.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg2.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg4.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg26.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg25.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg5.png`
                }, 
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg18.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg218.png`
                },
                
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg6.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg24.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg28.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg8.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg9.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg29.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg210.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg10.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg11.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg211.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg212.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg12.png`
                }, 
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg213.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg13.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg15.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg215.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg214.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg14.png`
                },
                
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg16.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg216.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg217.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg17.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg7.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-bg27.png`
                },





            ],
            "start_now_link": "https://spyne.ai/category/cars/try",
        },
        "media_logos_section" : {
            "heading": "You Won't Just Hear it From Us   ",
            "sub-heading": "",
            "enterprises_list": [
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client1.png`, 
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client2.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client4.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client3.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client5.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/yahoo.png`, 
            ]
        },
        "clients_slider" :[
            {
                "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client6.png`,
                "description" : "Spyne is a seamless and impressive solution that has streamlined our vehicle photography and accelerated our time to market. The team at Spyne are hugely supportive and easy to deal with, an amazing product and team!",
            },
            { //Amazon
                "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/amazon.png`,
                "description" : "Spyne.ai has always been a valuable service partner in enabling SMBs in online marketplace. Excellent in handling projects. A big shoutout to Vivek  Vishnoi, Shahab and their team of KAMs for handling all key projects well. Kudos to the whole team!",
            },
            { //Karvi
                "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/karvi-client.png`,
                "description" : "Amazing tool! The Spyne experience is incredible because it offers professional photographs at the moment. The Spyne service helps us to get images of excellence on our site, being able to publish our products in short terms of time. It's wonderful to work with such a professional and collaborative group of people, always reaching for the best results.",
            },
            { //Flipkart
                "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client5.png`,
                "description" : "Spyne is our strategic partner in helping us scale our image/photo-operations across locations and the AI has definitely helped us across the journey. I'd like to rate Spyne 4 out of 5 for the overall experience with their product and services. ",
            },
            
        ]
        
        

    },
    "fashion" : {
        "isSubCategoryExist": false,
        "prod_cat_id" : "cat_skJ7HIvnc",
        "product_sub_cat_id": "",
        "redirect_url" : "/category/fashion/try",
        "hero_section" :{
            "heading" : "Create Stunning Fashion Photos That Boost Online Sales ",
            "sub_heading" :'Spyne’s "No Code"  solution helps you instantly generate high quality images that drive 40% better conversions. ',
            "banner_images" : [`${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fashion-hero.gif`]
        },
        "enterprises_section" : {
            "heading": "Trusted By The World's Fastest Growing Companies ",
            "sub-heading": "",
            "enterprises_list": [
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client1.png`, 
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client2.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client3.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client4.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client5.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client6.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-n-bike.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/karvi-client.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client9.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client10.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client11.png`
            ]
        },
        // Mobile App section 
        "app_section" : {
            "heading" : "Shoot Anywhere In The World ",
            "sub_heading" : "Empowering your business with high-quality visuals that boost online engagement by upto 200%",
            "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/mobile-app.png`,
            "side_image": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fashion-mobile.gif`,
            "content" : [
                {
                    "content_heading" : "Shoot Like a Pro",
                    "content_subheading" : "Engage your visitors on your website with immersive visuals",
                    "accordion_item_on_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord1.png`,
                    "accordion_item_off_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord01.png`,
                    "content_description": [
                        {
                            "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                            "text": "Follow AI sensor to shoot stunning fashion images",
                        },
                        {
                            "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                            "text": "Engage your visitors on your website with immersive visuals     ",
                        }, 
                    ]
                },
                {
                    "content_heading" : "Edit images — 100% automatically ",
                    "content_subheading" : "Use 500X faster transformative tech to edit your images in bulk",
                    "accordion_item_on_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord2.png`,
                    "accordion_item_off_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord02.png`,
                    "content_description": [
                        {
                            "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                            "text": "You can choose from 100s of premium backgrounds   ",
                        },
                        {
                            "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                            "text": "1-Click to edit your images as per your marketplace guidelines ",
                        }, 
                    ]
                },
                {
                    "content_heading" : "Publish Instantly",
                    "content_subheading" : "Publish your images to your dealership website faster than ever  ",
                    "accordion_item_on_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord3.png`,
                    "accordion_item_off_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord03.png`,
                    "content_description": [
                        {
                            "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                            "text": "Download and publish final images to your website instantly",
                        },
                        {
                            "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                            "text": "Decrease cataloging time by making your cars live 90% faster",
                        }, 
                    ]
                },
            ]
        },
        "web_section" : {
            "heading" : "Create Marketplace-Ready Images With AI — 500x Faster    ",
            "sub_heading" : "",
            "banner_heading" : "The Best Fashion Image Editing Tool, Ever — 100% automatic ",
            "banner_sub_heading" : "We help you create stunning fashion photos for your business that boost conversions by 40% using the power of AI",
            "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/web-app.png`,
            "banner_image2" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/web-fs.png`,
            "web_description" : [
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Effortlessly edit hundreds of images instantly  ",
                },
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Choose from 100s premium & creative templates",
                },
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Turn inconsistent catalogs to engaging & uniform catalogs in real time",
                }
            ],
            "start_now_link": "https://www.spyne.ai/category/fashion/try"
        },
        "api_section" : {
            "heading" : "Automate, Simplify, & Scale Your Work",
            "sub_heading" : "",
            "banner_heading" : "Use Computer Vision & AI Tech to Bring Efficiency to Your Workflow     ",
            "banner_sub_heading" : "Effortlessly automate and streamline your workflow with our APIs and reduce week-long processes to a few minutes. ",
            "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/api.png`,
            "api_description" : [
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Transform your massive catalogs instantly ",
                },
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Save 90% of your time by automating repetitive tasks",
                },
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Minimize the operational costs significantly ",
                }
            ],
            "start_now_link": "https://documenter.getpostman.com/view/10990096/TzRX7Qbq"
        },
        "dashboard_section" : {
            "heading" : "One Place To Manage & Measure Your Shoots ",
            "sub_heading" : "",
            "banner_heading" : "",
            "banner_sub_heading" : "Single dashboard to track and manage all your shoots in real time and download to publish your images directly to your website. ",
            "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/dashboard.png`,
            "api_description" : [
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Affordable way to create quality 360° Walkarounds in minute",
                },
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Make your videos live faster onto your website instantly",
                },
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Let your shoppers explore your vehicles & help them make informed decisions.",
                }
            ],
            "small_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fashion-middle.png`,
            "zoomInImages" : [
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/fashion-middle.png', //Middle Image of dashboard
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-2.png',
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-3.png', 
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-4.png',
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-5.png',
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-6.png',
            ],
           
        },
        "templates" : {
            "heading" : "Premium Templates To Elevate Customer Experience",
            "sub_heading" : "Choose a unique background from 60+ Premium templates and creative backgrounds",
            "custom_images" :[
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/model-bg21.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/model-bg1.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/model-bg2.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/model-bg22.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/model-bg9.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/model-bg29.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/model-bg24.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/model-bg4.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/model-bg12.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/model-bg32.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/model-bg26.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/model-bg6.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/model-bg27.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/model-bg7.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/model-bg8.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/model-bg28.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/model-bg23.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/model-bg3.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/model-bg10.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/model-bg30.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/model-bg31.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/model-bg11.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/model-bg5.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/model-bg25.png`
                },
            ],
            "start_now_link": "https://www.spyne.ai/category/fashion/try",
        },
        "media_logos_section" : {
            "heading": "You Won't Just Hear it From Us   ",
            "sub-heading": "",
            "enterprises_list": [
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client1.png`, 
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client2.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client4.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client3.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client5.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/yahoo.png`, 
            ]
        },
        "clients_slider" :[
            {
                "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client6.png`,
                "description" : "Spyne is a seamless and impressive solution that has streamlined our vehicle photography and accelerated our time to market. The team at Spyne are hugely supportive and easy to deal with, an amazing product and team!",
            },
            { //Amazon
                "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/amazon.png`,
                "description" : "Spyne.ai has always been a valuable service partner in enabling SMBs in online marketplace. Excellent in handling projects. A big shoutout to Vivek  Vishnoi, Shahab and their team of KAMs for handling all key projects well. Kudos to the whole team!",
            },
            { //Karvi
                "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/karvi.png`,
                "description" : "Amazing tool! The Spyne experience is incredible because it offers professional photographs at the moment. The Spyne service helps us to get images of excellence on our site, being able to publish our products in short terms of time. It's wonderful to work with such a professional and collaborative group of people, always reaching for the best results.",
            },
            { //Flipkart
                "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client5.png`,
                "description" : "Spyne is our strategic partner in helping us scale our image/photo-operations across locations and the AI has definitely helped us across the journey. I'd like to rate Spyne 4 out of 5 for the overall experience with their product and services. ",
            },
            
        ]

    },
    "food" : {
        "isSubCategoryExist": false,
        "prod_cat_id" : "cat_Ujt0kuFxF",
        "product_sub_cat_id": "",
        "redirect_url" : "/category/food/try",
        "hero_section" :{
            "heading" : "Instantly Create Thumb-stopping Food Images That Drive Sales    ",
            "sub_heading" :"Create engaging images for your food business, Instagram, cookbooks and restaurant. Classifieds? Them too!",
            "banner_images" : [`${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-hero.gif`]
        },
        "enterprises_section" : {
            "heading": "Trusted By The World's Fastest Growing Companies ",
            "sub-heading": "",
            "enterprises_list": [
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client1.png`, 
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client2.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client3.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client4.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client5.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client6.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-n-bike.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/karvi-client.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client9.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client10.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client11.png`
            ]
        },
        // Mobile App section 
        "app_section" : {
            "heading" : "DIY App To Create Appetizing Food Photos",
            "sub_heading" : "Empowering your business with high-quality visuals that boost online engagement by upto 200%",
            "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/mobile-app.png`,
            "side_image": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-mobile.gif`,
            "content" : [
                {
                    "content_heading" : "Shoot Like a Pro",
                    "content_subheading" : "Engage your visitors on your website with immersive visuals",
                    "accordion_item_on_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord1.png`,
                    "accordion_item_off_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord01.png`,
                    "content_description": [
                        {
                            "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                            "text": "Follow in-app AI sensor to click mouth-watering food images ",
                        },
                        {
                            "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                            "text": "Click the best food images at 0° and 45° angles",
                        }, 
                    ]
                },
                {
                    "content_heading" : "Edit images - 100% automatically     ",
                    "content_subheading" : "Use 500X faster transformative tech to edit your images in bulk",
                    "accordion_item_on_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord2.png`,
                    "accordion_item_off_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord02.png`,
                    "content_description": [
                        {
                            "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                            "text": "You can choose from 60+ food backgrounds and templates ",
                        },
                        {
                            "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                            "text": "The AI app automatically edits all your images in a few minutes",
                        }, 
                    ]
                },
                {
                    "content_heading" : "Publish Instantly",
                    "content_subheading" : "Publish your images to your dealership website faster than ever  ",
                    "accordion_item_on_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord3.png`,
                    "accordion_item_off_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord03.png`,
                    "content_description": [
                        {
                            "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                            "text": "Download ready-to-use food images right from the app",
                        },
                        {
                            "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                            "text": "Instantly publish final food images to your website  ",
                        }, 
                    ]
                },
            ]
        },
        "web_section" : {
            "heading" : "Create Ready-to-use Food Image With AI in Seconds  ",
            "sub_heading" : "",
            "banner_heading" : "Turn Your Average Food Images into Premium Images — 100% Automatically ",
            "banner_sub_heading" : "500x faster image editing tool to create sleek & clean food photos that boost your conversions by over 25%",
            "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/web-app.png`,
            "banner_image2" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/web-fd.png`,
            "web_description" : [
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Effortlessly edit hundreds of food images instantly ",
                },
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Choose from 60+ premium & creative templates    ",
                },
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Turn inconsistent catalogs into engaging & uniform catalogs in real time",
                }
            ],
            "start_now_link": "https://www.spyne.ai/category/food/try"
        },
        "api_section" : {
            "heading" : "Automate, Simplify & Scale Your Work ",
            "sub_heading" : "",
            "banner_heading" : "Use Computer Vision & AI Tech to Bring Efficiency to Your Workflow     ",
            "banner_sub_heading" : "Effortlessly automate and streamline your workflow with our APIs and reduce week-long processes to a few minutes. ",
            "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/api.png`,
            "api_description" : [
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Transform your massive catalogs instantly ",
                },
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Save 90% of your time by automating repetitive tasks  ",
                },
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Minimize the operational costs significantly ",
                }
            ],
            "start_now_link": "https://documenter.getpostman.com/view/10990096/TzRX7Qbq"
        },
        "dashboard_section" : {
            "heading" : "One Place To Manage & Measure Your Shoots",
            "sub_heading" : "",
            "banner_heading" : "",
            "banner_sub_heading" : "Single dashboard to track and manage all your shoots in real time and download to publish your images directly to your website. ",
            "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/dashboard.png`,
            "api_description" : [
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Affordable way to create quality 360° Walkarounds in minute",
                },
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Make your videos live faster onto your website instantly",
                },
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Let your shoppers explore your vehicles & help them make informed decisions.",
                }
            ],
            "small_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-middle.png`,
            "zoomInImages" : [
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/food-middle.png', //Middle Image of dashboard
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-2.png',
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-3.png', 
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-4.png',
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-5.png',
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-6.png',
            ],
        },
        "templates" : {
            "heading" : "Premium Backgrounds For Premium Aesthetics",
            "sub_heading" : "Choose from hundreds of free yet stunning food backgrounds and templates       ",
            "custom_images" :[
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg1.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-curry.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg7.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg17.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg221.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg21.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg6.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg16.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg5.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg15.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg22.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg222.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg2.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-rice.png`
                },

                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg13.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg3.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg8.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg18.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg4.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg14.png`
                },
                
               
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg25.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg225.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg112.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg12-1.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg19.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg9.png`
                },

                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg226.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg26.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg111.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg1-2.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg23.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg223.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg10.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg110.png`
                },
                
                
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg27.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food-bg227.png`
                },
            ],
            "start_now_link": "https://www.spyne.ai/category/food/try",
        },
        "media_logos_section" : {
            "heading": "You Won't Just Hear it From Us   ",
            "sub-heading": "",
            "enterprises_list": [
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client1.png`, 
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client2.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client4.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client3.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client5.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/yahoo.png`, 
            ]
        },
        "clients_slider" :[
            {
                "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client6.png`,
                "description" : "Spyne is a seamless and impressive solution that has streamlined our vehicle photography and accelerated our time to market. The team at Spyne are hugely supportive and easy to deal with, an amazing product and team!",
            },
            { //Amazon
                "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/amazon.png`,
                "description" : "Spyne.ai has always been a valuable service partner in enabling SMBs in online marketplace. Excellent in handling projects. A big shoutout to Vivek  Vishnoi, Shahab and their team of KAMs for handling all key projects well. Kudos to the whole team!",
            },
            { //Karvi
                "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/karvi.png`,
                "description" : "Amazing tool! The Spyne experience is incredible because it offers professional photographs at the moment. The Spyne service helps us to get images of excellence on our site, being able to publish our products in short terms of time. It's wonderful to work with such a professional and collaborative group of people, always reaching for the best results.",
            },
            { //Flipkart
                "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client5.png`,
                "description" : "Spyne is our strategic partner in helping us scale our image/photo-operations across locations and the AI has definitely helped us across the journey. I'd like to rate Spyne 4 out of 5 for the overall experience with their product and services. ",
            },
           
           
        ]

    },


    "fabric" : {
        "isSubCategoryExist": true,
        "category":'fabric',
        "subCategories":[
            "saree","suit"
        ],
        "prod_cat_id" : "cat_skJ7HIvnc",

        "saree":{ 
            "product_sub_cat_id": "prod_WiE3dLKOs",
            "redirect_url" : "/category/fabric/saree/try",
            "hero_section" :{
                "heading" : "Turn Fabric Photos into Model Images — 100% Automatically",
                "sub_heading" :"Convert fabric or garments photo samples to beautiful model images without the hassle of professional shoots.",
                "banner_images" : [`${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/saree-hero.gif`]
            },
            "enterprises_section" : {
                "heading": "Trusted by the world's fastest-growing companies ",
                "sub-heading": "",
                "enterprises_list": [
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client1.png`, 
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client2.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client3.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client4.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client5.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client6.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-n-bike.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/karvi-client.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client9.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client10.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client11.png`
                ]
            },
            // Mobile App section 
            "app_section" : {
                "heading" : "Turn Any Fabric Into Model Image Instantly",
                "sub_heading" : "Empowering your business with high-quality visuals that boost online engagement by upto 200%",
                "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/mobile-app.png`,
                "side_image": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/saree-mobile.gif`,
                "content" : [
                    {
                        "content_heading" : "Shoot Anywhere",
                        "content_subheading" : "Click photos of unstitched dresses (saree, suits etc) Use AI app sensors to shoot the right flat photos",
                        "accordion_item_on_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord1.png`,
                        "accordion_item_off_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord01.png`,
                        "content_description": [
                            {
                                "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                                "text": "Follow in-app AI sensor to click mouth-watering food images ",
                            },
                            {
                                "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                                "text": "Click the best food images at 0° and 45° angles",
                            }, 
                        ]
                    },
                    {
                        "content_heading" : "Edit images — 100% automatically",
                        "content_subheading" : "You can choose from different backgrounds, setups & models AI app will instantly turn your fabric photo into model images ",
                        "accordion_item_on_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord2.png`,
                        "accordion_item_off_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord02.png`,
                        "content_description": [
                            {
                                "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                                "text": "You can choose from 60+ food backgrounds and templates ",
                            },
                            {
                                "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                                "text": "The AI app automatically edits all your images in a few minutes",
                            }, 
                        ]
                    },
                    {
                        "content_heading" : "Publish Instantly",
                        "content_subheading" : "Download ready-to-use model images right from the app Instantly publish final images to your website",
                        "accordion_item_on_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord3.png`,
                        "accordion_item_off_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord03.png`,
                        "content_description": [
                            {
                                "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                                "text": "Download ready-to-use food images right from the app",
                            },
                            {
                                "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                                "text": "Instantly publish final food images to your website  ",
                            }, 
                        ]
                    },
                ]
            },
            "web_section" : {
                "heading" : "Use AI To Drape Any Fabric onto a Model in Seconds",
                "sub_heading" : "",
                "banner_heading" : "Drape Your Unstitched Dress Materials onto Live Models — 100% Automatically  ",
                "banner_sub_heading" : "No need to stitch samples for cataloging — upload flat photos of unstitched garments & let our AI drape them onto models instantly.",
                "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/web-app.png`,
                "banner_image2" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/web-saree.png`,
                "web_description" : [
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Upload Images of Pallu, Body & Blouse ",
                    },
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Choose from 10+ live models, creative templates and setups",
                    },
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Create photo-realistic visuals of your unstitched dresses in seconds ",
                    }
                ],
                "start_now_link": "https://www.spyne.ai/category/fabric/saree/try"
            },
            "api_section" : {
                "heading" : "Automate, Simplify & Scale Your Work ",
                "sub_heading" : "",
                "banner_heading" : "Use Computer Vision & AI Tech to Bring Efficiency to Your Workflow                ",
                "banner_sub_heading" : "Effortlessly automate and streamline your workflow with our APIs and reduce week-long processes to a few minutes.",
                "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/api.png`,
                "api_description" : [
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Turn fabric into live models for cataloging ",
                    },
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Save 90% of your time by automating repetitive tasks ",
                    },
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "No hassle to stitch garments or have photoshoots",
                    }
                ],
                "start_now_link": "https://documenter.getpostman.com/view/10990096/TzRX7Qbq"
            },
            "dashboard_section" : {
                "heading" : "One Place To Manage & Measure Your Shoots    ",
                "sub_heading" : "",
                "banner_heading" : "",
                "banner_sub_heading" : "Single dashboard to track and manage all your shoots in real time and download to publish your images directly to your website. ",
                "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/dashboard.png`,
                "api_description" : [
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Affordable way to create quality 360° Walkarounds in minute",
                    },
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Make your videos live faster onto your website instantly",
                    },
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Let your shoppers explore your vehicles & help them make informed decisions.",
                    }
                ],
                "small_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/saree-middle.png`,
                "zoomInImages" : [
                    'https://storage.googleapis.com/spyne-website/SpyneHome-v2/fabric/saree-middle.png', //Middle Image of dashboard
                    'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-2.png',
                    'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-3.png', 
                    'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-4.png',
                    'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-5.png',
                    'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-6.png',
                ],
            },
            "templates" : {
                "heading" : "Creative Templates & Setups For All Categories   ",
                "sub_heading" : "Choose from 25+ creative templates, setups and models for accurate photorealistic visualizations                 ",
                "custom_images" :[
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/saree21.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/saree1.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/saree2.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/saree22.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/saree3.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/saree21.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/saree23.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/saree4.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/saree5.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/saree24.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/saree6.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/saree23.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/saree7.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/saree24.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/saree8.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/saree23.png`
                    },

                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/saree22.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/saree9.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/saree10.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/saree23.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/saree11.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/saree22.png`
                    },
                    
                
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/saree24.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/saree12.png`
                    },
                     
                    
                ],
                "start_now_link": "https://www.spyne.ai/category/fabric/saree/try",
            },
            "media_logos_section" : {
                "heading": "You Won't Just Hear it From Us   ",
                "sub-heading": "",
                "enterprises_list": [
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client1.png`, 
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client2.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client4.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client3.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client5.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/yahoo.png`, 
                ]
            },
            "clients_slider" :[
                {
                    "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client6.png`,
                    "description" : "Spyne is a seamless and impressive solution that has streamlined our vehicle photography and accelerated our time to market. The team at Spyne are hugely supportive and easy to deal with, an amazing product and team!",
                },
                { //Amazon
                    "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/amazon.png`,
                    "description" : "Spyne.ai has always been a valuable service partner in enabling SMBs in online marketplace. Excellent in handling projects. A big shoutout to Vivek  Vishnoi, Shahab and their team of KAMs for handling all key projects well. Kudos to the whole team!",
                },
                { //Karvi
                    "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/karvi.png`,
                    "description" : "Amazing tool! The Spyne experience is incredible because it offers professional photographs at the moment. The Spyne service helps us to get images of excellence on our site, being able to publish our products in short terms of time. It's wonderful to work with such a professional and collaborative group of people, always reaching for the best results.",
                },
                { //Flipkart
                    "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client5.png`,
                    "description" : "Spyne is our strategic partner in helping us scale our image/photo-operations across locations and the AI has definitely helped us across the journey. I'd like to rate Spyne 4 out of 5 for the overall experience with their product and services. ",
                },
            
            
            ]
        },
        "suit":{
           
            "product_sub_cat_id": "prod_ZiE6ALKwe",
            "redirect_url" : "/category/fabric/suit/try",
            "hero_section" :{
                "heading" : "Turn Fabric Photos into Model Images — 100% Automatically",
                "sub_heading" :"Convert fabric or garments photo samples to beautiful model images without the hassle of professional shoots.",
                "banner_images" : [`${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/suit-hero.gif`]
            },
            "enterprises_section" : {
                "heading": "Trusted by the world's fastest-growing companies        ",
                "sub-heading": "",
                "enterprises_list": [
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client1.png`, 
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client2.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client3.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client4.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client5.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client6.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-n-bike.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/karvi-client.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client9.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client10.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client11.png`
                ]
            },
            // Mobile App section 
            "app_section" : {
                "heading" : "Turn Any Fabric Into Model Image Instantly",
                "sub_heading" : "Empowering your business with high-quality visuals that boost online engagement by upto 200%",
                "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/mobile-app.png`,
                "side_image": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/suit-mobile.gif`,
                "content" : [
                    {
                        "content_heading" : "Shoot Anywhere",
                        "content_subheading" : "Click photos of unstitched dresses (saree, suits etc) Use AI app sensors to shoot the right flat photos",
                        "accordion_item_on_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord1.png`,
                        "accordion_item_off_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord01.png`,
                        "content_description": [
                            {
                                "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                                "text": "Follow in-app AI sensor to click mouth-watering food images ",
                            },
                            {
                                "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                                "text": "Click the best food images at 0° and 45° angles",
                            }, 
                        ]
                    },
                    {
                        "content_heading" : "Edit images — 100% automatically",
                        "content_subheading" : "You can choose from different backgrounds, setups & models AI app will instantly turn your fabric photo into model images ",
                        "accordion_item_on_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord2.png`,
                        "accordion_item_off_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord02.png`,
                        "content_description": [
                            {
                                "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                                "text": "You can choose from 60+ food backgrounds and templates ",
                            },
                            {
                                "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                                "text": "The AI app automatically edits all your images in a few minutes",
                            }, 
                        ]
                    },
                    {
                        "content_heading" : "Publish Instantly",
                        "content_subheading" : "Download ready-to-use model images right from the app Instantly publish final images to your website",
                        "accordion_item_on_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord3.png`,
                        "accordion_item_off_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord03.png`,
                        "content_description": [
                            {
                                "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                                "text": "Download ready-to-use food images right from the app",
                            },
                            {
                                "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                                "text": "Instantly publish final food images to your website  ",
                            }, 
                        ]
                    },
                ]
            },
            "web_section" : {
                "heading" : "Use AI To Drape Any Fabric onto a Model in Seconds",
                "sub_heading" : "",
                "banner_heading" : "Drape Your Unstitched Dress Materials onto Live Models — 100% Automatically  ",
                "banner_sub_heading" : "No need to stitch samples for cataloging — upload flat photos of unstitched garments & let our AI drape them onto models instantly.",
                "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/web-app.png`,
                "banner_image2" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/web-suit.png`,
                "web_description" : [
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Upload Images of Pallu, Body & Blouse ",
                    },
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Choose from 10+ live models, creative templates and setups",
                    },
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Create photo-realistic visuals of your unstitched dresses in seconds ",
                    }
                ],
                "start_now_link": "https://www.spyne.ai/category/fabric/suit/try"
            },
            "api_section" : {
                "heading" : "Automate, Simplify & Scale Your Work ",
                "sub_heading" : "",
                "banner_heading" : "Use Computer Vision & AI Tech to Bring Efficiency to Your Workflow                ",
                "banner_sub_heading" : "Effortlessly automate and streamline your workflow with our APIs and reduce week-long processes to a few minutes.",
                "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/api.png`,
                "api_description" : [
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Turn fabric into live models for cataloging ",
                    },
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Save 90% of your time by automating repetitive tasks ",
                    },
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "No hassle to stitch garments or have photoshoots",
                    }
                ],
                "start_now_link": "https://documenter.getpostman.com/view/10990096/TzRX7Qbq"
            },
            "dashboard_section" : {
                "heading" : "One Place To Manage & Measure Your Shoots    ",
                "sub_heading" : "",
                "banner_heading" : "",
                "banner_sub_heading" : "Single dashboard to track and manage all your shoots in real time and download to publish your images directly to your website. ",
                "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/dashboard.png`,
                "api_description" : [
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Affordable way to create quality 360° Walkarounds in minute",
                    },
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Make your videos live faster onto your website instantly",
                    },
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Let your shoppers explore your vehicles & help them make informed decisions.",
                    }
                ],
                "small_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/suit-middle.png`,
                "zoomInImages" : [
                    'https://storage.googleapis.com/spyne-website/SpyneHome-v2/fabric/suit-middle.png', //Middle Image of dashboard
                    'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-2.png',
                    'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-3.png', 
                    'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-4.png',
                    'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-5.png',
                    'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-6.png',
                ],
            },
            "templates" : {
                "heading" : "Creative Templates & Setups For All Categories   ",
                "sub_heading" : "Choose from 25+ creative templates, setups and models for accurate photorealistic visualizations                 ",
                "custom_images" :[
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/suit21.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/suit1.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/suit2.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/suit22.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/suit23.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/suit3.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/suit4.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/suit24.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/suit25.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/suit5.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/suit6.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/suit24.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/suit7.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/suit23.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/suit26.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/suit8.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/suit9.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/suit21.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/suit10.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/suit26.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/suit24.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/suit11.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/suit12.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric/suit25.png`
                    },
                ],
                "start_now_link": "https://www.spyne.ai/category/fabric/suit/try",
            },
            "media_logos_section" : {
                "heading": "You Won't Just Hear it From Us   ",
                "sub-heading": "",
                "enterprises_list": [
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client1.png`, 
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client2.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client4.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client3.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client5.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/yahoo.png`, 
                ]
            },
            "clients_slider" :[
                {
                    "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client6.png`,
                    "description" : "Spyne is a seamless and impressive solution that has streamlined our vehicle photography and accelerated our time to market. The team at Spyne are hugely supportive and easy to deal with, an amazing product and team!",
                },
                { //Amazon
                    "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/amazon.png`,
                    "description" : "Spyne.ai has always been a valuable service partner in enabling SMBs in online marketplace. Excellent in handling projects. A big shoutout to Vivek  Vishnoi, Shahab and their team of KAMs for handling all key projects well. Kudos to the whole team!",
                },
                { //Karvi
                    "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/karvi.png`,
                    "description" : "Amazing tool! The Spyne experience is incredible because it offers professional photographs at the moment. The Spyne service helps us to get images of excellence on our site, being able to publish our products in short terms of time. It's wonderful to work with such a professional and collaborative group of people, always reaching for the best results.",
                },
                { //Flipkart
                    "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client5.png`,
                    "description" : "Spyne is our strategic partner in helping us scale our image/photo-operations across locations and the AI has definitely helped us across the journey. I'd like to rate Spyne 4 out of 5 for the overall experience with their product and services. ",
                },
            
            
            ]
        },

    },
    
    "furnishing" : {
        "isSubCategoryExist": true,
        "category":'furnishing',
        "subCategories":[
            "curtain","cushion", "bedsheet"
        ],
        "prod_cat_id" : "cat_skJ7HIvnc",
        
        "curtain":{ 
            "product_sub_cat_id": "prod_Ze234dhKu",
            "redirect_url" : "/category/home-furnishing/curtains/try",
            "hero_section" :{
                "heading" : "AI Draping To Create Lifestyle Shots Instantly",
                "sub_heading" :"Instantly convert images of bed sheets, cushions, curtains, into lifestyle shots with AI rendering software. ",
                "banner_images" : [`${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain-hero.gif`]
            },
            "enterprises_section" : {
                "heading": "Trusted by the world's fastest-growing companies ",
                "sub-heading": "",
                "enterprises_list": [
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client1.png`, 
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client2.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client3.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client4.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client5.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client6.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-n-bike.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/karvi-client.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client9.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client10.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client11.png`
                ]
            },
            // Mobile App section 
            "app_section" : {
                "heading" : "Bring Your Products to Life With AI-Powered 3D Rendering",
                "sub_heading" : "Empowering your business with high-quality visuals that boost online engagement by upto 200%",
                "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/mobile-app.png`,
                "side_image": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain-mobile.gif`,
                "content" : [
                    {
                        "content_heading" : "Shoot Anywhere",
                        "content_subheading" : "  ",
                        "accordion_item_on_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord1.png`,
                        "accordion_item_off_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord01.png`,
                        "content_description": [
                            {
                                "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                                "text": "Click photos of products such as bedsheets, curtains, table cloth, ",
                            },
                            {
                                "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                                "text": "Use AI app sensors to shoot the right flat photos",
                            }, 
                        ]
                    },
                    {
                        "content_heading" : "Edit images - 100% automatically     ",
                        "content_subheading" : "",
                        "accordion_item_on_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord2.png`,
                        "accordion_item_off_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord02.png`,
                        "content_description": [
                            {
                                "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                                "text": "Choose from different setups, angles and templates",
                            },
                            {
                                "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                                "text": "AI app will instantly render images in realistic lifestyle shots",
                            }, 
                        ]
                    },
                    {
                        "content_heading" : "Publish Instantly",
                        "content_subheading" : "Publish your images to your dealership website faster than ever  ",
                        "accordion_item_on_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord3.png`,
                        "accordion_item_off_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord03.png`,
                        "content_description": [
                            {
                                "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                                "text": "Download e-commerce-ready images right from the app",
                            },
                            {
                                "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                                "text": "Instantly publish final images to your website",
                            }, 
                        ]
                    },
                ]
            },
            "web_section" : {
                "heading" : "Drape Any Fabric onto Home Furnishing Product With AI                ",
                "sub_heading" : "",
                "banner_heading" : "Create dynamic product catalogs 500X faster         ",
                "banner_sub_heading" : "No need to invest in professional photoshoots — upload flat photos & let our AI create lifestyle shots instantly. ",
                "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/web-app.png`,
                "banner_image2" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/web-curtain.png`,
                "web_description" : [
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Upload Images of Bedsheets, Curtains, Cushions, etc                 ",
                    },
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Choose from 20+ creative templates and setups",
                    },
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Create photo-realistic lifestyle shots in seconds ",
                    }
                ],
                "start_now_link": "https://www.spyne.ai/category/home-furnishing/curtains/try"
            },
            "api_section" : {
                "heading" : "Automate, Simplify & Scale Your Work                ",
                "sub_heading" : "",
                "banner_heading" : "Use Computer Vision & AI Tech to Bring Efficiency to Your Workflow                ",
                "banner_sub_heading" : "Effortlessly automate and streamline your workflow with our APIs and reduce week-long processes to a few minutes. ",
                "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/api.png`,
                "api_description" : [
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Turn fabric into lifestyle shots for cataloging  ",
                    },
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Save 90% of your time by automating repetitive tasks",
                    },
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "No hassle to e-commerce photoshoot post-processing",
                    }
                ],
                "start_now_link": "https://documenter.getpostman.com/view/10990096/TzRX7Qbq"
            },
            "dashboard_section" : {
                "heading" : "One Place To Manage & Measure Your Shoots",
                "sub_heading" : "",
                "banner_heading" : "",
                "banner_sub_heading" : "Single dashboard to track and manage all your shoots in real time and download to publish your images directly to your website.  ",
                "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/dashboard.png`,
                "api_description" : [
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Affordable way to create quality 360° Walkarounds in minute",
                    },
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Make your videos live faster onto your website instantly",
                    },
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Let your shoppers explore your vehicles & help them make informed decisions.",
                    }
                ],
                "small_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain-middle.png`,
                "zoomInImages" : [
                    'https://storage.googleapis.com/spyne-website/SpyneHome-v2/furnishing/curtain-middle.png', //Middle Image of dashboard
                    'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-2.png',
                    'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-3.png', 
                    'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-4.png',
                    'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-5.png',
                    'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-6.png',
                ],
            },
            "templates" : {
                "heading" : "Premium Backgrounds For Premium Aesthetics",
                "sub_heading" : "Choose from hundreds of free yet stunning food backgrounds and templates       ",
                "custom_images" :[
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain31.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain1.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain2.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain36.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain33.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain3.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain4.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain35.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain32.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain5.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain6.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain36.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain7.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain43.png`
                    },
 
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain38.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain8.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain9.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain45.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain40.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain10.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain11.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain39.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain40.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain12.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain13.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain47.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain14.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain41.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain42.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain15.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain16.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain52.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain17.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain44.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain48.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/curtain18.png`
                    },
                ],
                "start_now_link": "https://www.spyne.ai/category/home-furnishing/curtains/try",
            },
            "media_logos_section" : {
                "heading": "You Won't Just Hear it From Us   ",
                "sub-heading": "",
                "enterprises_list": [
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client1.png`, 
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client2.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client4.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client3.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client5.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/yahoo.png`, 
                ]
            },
            "clients_slider" :[
                {
                    "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client6.png`,
                    "description" : "Spyne is a seamless and impressive solution that has streamlined our vehicle photography and accelerated our time to market. The team at Spyne are hugely supportive and easy to deal with, an amazing product and team!",
                },
                { //Amazon
                    "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/amazon.png`,
                    "description" : "Spyne.ai has always been a valuable service partner in enabling SMBs in online marketplace. Excellent in handling projects. A big shoutout to Vivek  Vishnoi, Shahab and their team of KAMs for handling all key projects well. Kudos to the whole team!",
                },
                { //Karvi
                    "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/karvi.png`,
                    "description" : "Amazing tool! The Spyne experience is incredible because it offers professional photographs at the moment. The Spyne service helps us to get images of excellence on our site, being able to publish our products in short terms of time. It's wonderful to work with such a professional and collaborative group of people, always reaching for the best results.",
                },
                { //Flipkart
                    "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client5.png`,
                    "description" : "Spyne is our strategic partner in helping us scale our image/photo-operations across locations and the AI has definitely helped us across the journey. I'd like to rate Spyne 4 out of 5 for the overall experience with their product and services. ",
                },
            
            
            ]
        },
        "cushion":{
            "product_sub_cat_id": "prod_U342qkis",
            "redirect_url" : "/category/home-furnishing/cushions/try",
            "hero_section" :{
                "heading" : "AI Draping To Create Lifestyle Shots Instantly",
                "sub_heading" :"Instantly convert images of bed sheets, cushions, curtains, into lifestyle shots with AI rendering software. ",
                "banner_images" : [`${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/cushion-hero.gif`]
            },
            "enterprises_section" : {
                "heading": "Trusted by the world's fastest-growing companies ",
                "sub-heading": "",
                "enterprises_list": [
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client1.png`, 
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client2.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client3.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client4.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client5.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client6.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-n-bike.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/karvi-client.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client9.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client10.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client11.png`
                ]
            },
            // Mobile App section 
            "app_section" : {
                "heading" : "Bring Your Products to Life With AI-Powered 3D Rendering",
                "sub_heading" : "Empowering your business with high-quality visuals that boost online engagement by upto 200%",
                "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/mobile-app.png`,
                "side_image": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/cushion-mobile.gif`,
                "content" : [
                    {
                        "content_heading" : "Shoot Anywhere",
                        "content_subheading" : "  ",
                        "accordion_item_on_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord1.png`,
                        "accordion_item_off_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord01.png`,
                        "content_description": [
                            {
                                "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                                "text": "Click photos of products such as bedsheets, curtains, table cloth, ",
                            },
                            {
                                "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                                "text": "Use AI app sensors to shoot the right flat photos",
                            }, 
                        ]
                    },
                    {
                        "content_heading" : "Edit images - 100% automatically     ",
                        "content_subheading" : "",
                        "accordion_item_on_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord2.png`,
                        "accordion_item_off_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord02.png`,
                        "content_description": [
                            {
                                "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                                "text": "Choose from different setups, angles and templates",
                            },
                            {
                                "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                                "text": "AI app will instantly render images in realistic lifestyle shots",
                            }, 
                        ]
                    },
                    {
                        "content_heading" : "Publish Instantly",
                        "content_subheading" : "Publish your images to your dealership website faster than ever  ",
                        "accordion_item_on_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord3.png`,
                        "accordion_item_off_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord03.png`,
                        "content_description": [
                            {
                                "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                                "text": "Download e-commerce-ready images right from the app",
                            },
                            {
                                "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                                "text": "Instantly publish final images to your website",
                            }, 
                        ]
                    },
                ]
            },
            "web_section" : {
                "heading" : "Drape Any Fabric onto Home Furnishing Product With AI                ",
                "sub_heading" : "",
                "banner_heading" : "Create dynamic product catalogs 500X faster         ",
                "banner_sub_heading" : "No need to invest in professional photoshoots — upload flat photos & let our AI create lifestyle shots instantly. ",
                "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/web-app.png`,
                "banner_image2" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/web-cushion.png`,
                "web_description" : [
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Upload Images of Bedsheets, Curtains, Cushions, etc                 ",
                    },
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Choose from 20+ creative templates and setups",
                    },
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Create photo-realistic lifestyle shots in seconds ",
                    }
                ],
                "start_now_link": "https://www.spyne.ai/category/home-furnishing/cushions/try"
            },
            "api_section" : {
                "heading" : "Automate, Simplify & Scale Your Work                ",
                "sub_heading" : "",
                "banner_heading" : "Use Computer Vision & AI Tech to Bring Efficiency to Your Workflow                ",
                "banner_sub_heading" : "Effortlessly automate and streamline your workflow with our APIs and reduce week-long processes to a few minutes. ",
                "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/api.png`,
                "api_description" : [
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Turn fabric into lifestyle shots for cataloging  ",
                    },
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Save 90% of your time by automating repetitive tasks",
                    },
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "No hassle to e-commerce photoshoot post-processing",
                    }
                ],
                "start_now_link": "https://documenter.getpostman.com/view/10990096/TzRX7Qbq"
            },
            "dashboard_section" : {
                "heading" : "One Place To Manage & Measure Your Shoots",
                "sub_heading" : "",
                "banner_heading" : "",
                "banner_sub_heading" : "Single dashboard to track and manage all your shoots in real time and download to publish your images directly to your website.  ",
                "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/dashboard.png`,
                "api_description" : [
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Affordable way to create quality 360° Walkarounds in minute",
                    },
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Make your videos live faster onto your website instantly",
                    },
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Let your shoppers explore your vehicles & help them make informed decisions.",
                    }
                ],
                "small_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/cushion-middle.png`,
                "zoomInImages" : [
                    'https://storage.googleapis.com/spyne-website/SpyneHome-v2/furnishing/cushion-middle.png', //Middle Image of dashboard
                    'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-2.png',
                    'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-3.png', 
                    'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-4.png',
                    'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-5.png',
                    'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-6.png',
                ],
            },
            "templates" : {
                "heading" : "Premium Backgrounds For Premium Aesthetics",
                "sub_heading" : "Choose from hundreds of free yet stunning food backgrounds and templates       ",
                "custom_images" :[
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush21.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush1.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush2.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush22.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush23.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush3.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush4.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush25.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush26.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush5.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush6.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush27.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush7.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush28.png`
                    },

                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush29.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush8.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush9.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush30.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush31.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush10.png`
                    },
                    
                
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush11.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush32.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush33.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush21.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush13.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush34.png`
                    },

                    
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush38.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush17.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush36.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush15.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush16.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush37.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush14.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush35.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush18.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/cush39.png`
                    },
                ],
                "start_now_link": "https://www.spyne.ai/category/home-furnishing/cushions/try",
            },
            "media_logos_section" : {
                "heading": "You Won't Just Hear it From Us   ",
                "sub-heading": "",
                "enterprises_list": [
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client1.png`, 
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client2.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client4.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client3.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client5.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/yahoo.png`, 
                ]
            },
            "clients_slider" :[
                {
                    "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client6.png`,
                    "description" : "Spyne is a seamless and impressive solution that has streamlined our vehicle photography and accelerated our time to market. The team at Spyne are hugely supportive and easy to deal with, an amazing product and team!",
                },
                { //Amazon
                    "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/amazon.png`,
                    "description" : "Spyne.ai has always been a valuable service partner in enabling SMBs in online marketplace. Excellent in handling projects. A big shoutout to Vivek  Vishnoi, Shahab and their team of KAMs for handling all key projects well. Kudos to the whole team!",
                },
                { //Karvi
                    "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/karvi.png`,
                    "description" : "Amazing tool! The Spyne experience is incredible because it offers professional photographs at the moment. The Spyne service helps us to get images of excellence on our site, being able to publish our products in short terms of time. It's wonderful to work with such a professional and collaborative group of people, always reaching for the best results.",
                },
                { //Flipkart
                    "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client5.png`,
                    "description" : "Spyne is our strategic partner in helping us scale our image/photo-operations across locations and the AI has definitely helped us across the journey. I'd like to rate Spyne 4 out of 5 for the overall experience with their product and services. ",
                },
            
            
            ]
        },
         
        "bedsheet":{ 
            "product_sub_cat_id": "prod_H12Opsu",
            "redirect_url" : "/category/home-furnishing/bedsheet/try",
            "hero_section" :{
                "heading" : "AI Draping To Create Lifestyle Shots Instantly",
                "sub_heading" :"Instantly convert images of bed sheets, cushions, curtains, into lifestyle shots with AI rendering software. ",
                "banner_images" : [`${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/bedsheet-hero.gif`]
            },
            "enterprises_section" : {
                "heading": "Trusted by the world's fastest-growing companies ",
                "sub-heading": "",
                "enterprises_list": [
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client1.png`, 
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client2.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client3.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client4.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client5.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client6.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-n-bike.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/karvi-client.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client9.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client10.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client11.png`
                ]
            },
            // Mobile App section 
            "app_section" : {
                "heading" : "Bring Your Products to Life With AI-Powered 3D Rendering",
                "sub_heading" : "Empowering your business with high-quality visuals that boost online engagement by upto 200%",
                "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/mobile-app.png`,
                "side_image": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/bedsheet-mobile.gif`,
                "content" : [
                    {
                        "content_heading" : "Shoot Anywhere",
                        "content_subheading" : "  ",
                        "accordion_item_on_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord1.png`,
                        "accordion_item_off_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord01.png`,
                        "content_description": [
                            {
                                "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                                "text": "Click photos of products such as bedsheets, curtains, table cloth, ",
                            },
                            {
                                "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                                "text": "Use AI app sensors to shoot the right flat photos",
                            }, 
                        ]
                    },
                    {
                        "content_heading" : "Edit images - 100% automatically     ",
                        "content_subheading" : "",
                        "accordion_item_on_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord2.png`,
                        "accordion_item_off_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord02.png`,
                        "content_description": [
                            {
                                "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                                "text": "Choose from different setups, angles and templates",
                            },
                            {
                                "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                                "text": "AI app will instantly render images in realistic lifestyle shots",
                            }, 
                        ]
                    },
                    {
                        "content_heading" : "Publish Instantly",
                        "content_subheading" : "Publish your images to your dealership website faster than ever  ",
                        "accordion_item_on_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord3.png`,
                        "accordion_item_off_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord03.png`,
                        "content_description": [
                            {
                                "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                                "text": "Download e-commerce-ready images right from the app",
                            },
                            {
                                "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                                "text": "Instantly publish final images to your website",
                            }, 
                        ]
                    },
                ]
            },
            "web_section" : {
                "heading" : "Drape Any Fabric onto Home Furnishing Product With AI                ",
                "sub_heading" : "",
                "banner_heading" : "Create dynamic product catalogs 500X faster         ",
                "banner_sub_heading" : "No need to invest in professional photoshoots — upload flat photos & let our AI create lifestyle shots instantly. ",
                "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/web-app.png`,
                "banner_image2" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing/web-bedsheet.png`,
                "web_description" : [
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Upload Images of Bedsheets, Curtains, Cushions, etc                 ",
                    },
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Choose from 20+ creative templates and setups",
                    },
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Create photo-realistic lifestyle shots in seconds ",
                    }
                ],
                "start_now_link": "https://www.spyne.ai/category/home-furnishing/bedsheet/try"
            },
            "api_section" : {
                "heading" : "Automate, Simplify & Scale Your Work                ",
                "sub_heading" : "",
                "banner_heading" : "Use Computer Vision & AI Tech to Bring Efficiency to Your Workflow                ",
                "banner_sub_heading" : "Effortlessly automate and streamline your workflow with our APIs and reduce week-long processes to a few minutes. ",
                "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/api.png`,
                "api_description" : [
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Turn fabric into lifestyle shots for cataloging  ",
                    },
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Save 90% of your time by automating repetitive tasks",
                    },
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "No hassle to e-commerce photoshoot post-processing",
                    }
                ],
                "start_now_link": "https://documenter.getpostman.com/view/10990096/TzRX7Qbq"
            },
            "dashboard_section" : {
                "heading" : "One Place To Manage & Measure Your Shoots",
                "sub_heading" : "",
                "banner_heading" : "",
                "banner_sub_heading" : "Single dashboard to track and manage all your shoots in real time and download to publish your images directly to your website.  ",
                "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/dashboard.png`,
                "api_description" : [
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Affordable way to create quality 360° Walkarounds in minute",
                    },
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Make your videos live faster onto your website instantly",
                    },
                    {
                        "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                        "text": "Let your shoppers explore your vehicles & help them make informed decisions.",
                    }
                ],
                "small_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bedsheet-middle.png`,
                "zoomInImages" : [
                    'https://storage.googleapis.com/spyne-website/SpyneHome-v2/furnishing/bedsheet-middle.png', //Middle Image of dashboard
                    'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-2.png',
                    'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-3.png', 
                    'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-4.png',
                    'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-5.png',
                    'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-6.png',
                ],
            },
            "templates" : {
                "heading" : "Premium Backgrounds For Premium Aesthetics",
                "sub_heading" : "Choose from hundreds of free yet stunning food backgrounds and templates       ",
                "custom_images" :[
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed1.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed21.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed22.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed2.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed3.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed23.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed24.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed4.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed5.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed25.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed6.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed26.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed27.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed7.png`
                    },

                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed8.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed28.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed29.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed9.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed10.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed30.png`
                    },
                    
                
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed31.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed11.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed12.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed32.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed13.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed33.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed38.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed14.png`
                    },
                   
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed15.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed35.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed37.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed16.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed14.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed34.png`
                    },
                    {
                        "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed39.png`,
                        "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/bed18.png`
                    },
                     
                ],
                "start_now_link": "https://www.spyne.ai/category/home-furnishing/bedsheet/try",
            },
            "media_logos_section" : {
                "heading": "You Won't Just Hear it From Us   ",
                "sub-heading": "",
                "enterprises_list": [
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client1.png`, 
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client2.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client4.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client3.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client5.png`,
                    `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/yahoo.png`, 
                ]
            },
            "clients_slider" :[
                {
                    "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client6.png`,
                    "description" : "Spyne is a seamless and impressive solution that has streamlined our vehicle photography and accelerated our time to market. The team at Spyne are hugely supportive and easy to deal with, an amazing product and team!",
                },
                { //Amazon
                    "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/amazon.png`,
                    "description" : "Spyne.ai has always been a valuable service partner in enabling SMBs in online marketplace. Excellent in handling projects. A big shoutout to Vivek  Vishnoi, Shahab and their team of KAMs for handling all key projects well. Kudos to the whole team!",
                },
                { //Karvi
                    "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/karvi.png`,
                    "description" : "Amazing tool! The Spyne experience is incredible because it offers professional photographs at the moment. The Spyne service helps us to get images of excellence on our site, being able to publish our products in short terms of time. It's wonderful to work with such a professional and collaborative group of people, always reaching for the best results.",
                },
                { //Flipkart
                    "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client5.png`,
                    "description" : "Spyne is our strategic partner in helping us scale our image/photo-operations across locations and the AI has definitely helped us across the journey. I'd like to rate Spyne 4 out of 5 for the overall experience with their product and services. ",
                },
            
            
            ]
        },

    },

    "footwear" : {
        "isSubCategoryExist": false,
        "prod_cat_id" : "cat_Ujt0kuFxX",
        "product_sub_cat_id": "",
        "redirect_url" : "/category/footwear/try",
        "hero_section" :{
            "heading" : "Your First Step To Beautiful Footwear Images Starts Here ",
            "sub_heading" :"Shoot & edit your footwear images with SpyneAI tech solutions — 100% automatic 100% scalable. Drop your image to see results.",
            "banner_images" : [`${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/footwear-hero.gif`]
        },
        "enterprises_section" : {
            "heading": "Trusted by the world's fastest growing companies",
            "sub-heading": "",
            "enterprises_list": [
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client1.png`, 
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client2.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client3.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client4.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client5.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client6.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-n-bike.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/karvi-client.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client9.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client10.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client11.png`
            ]
        },
        // Mobile App section 
        "app_section" : {
            "heading" : "DIY App To Shoot & Edit Your Footwear Images Instantly ",
            "sub_heading" : "Our cutting edge SpyneAI app enables online sellers to instantly create high quality images in fastest turnaround times",
            "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/mobile-app.png`,
            "side_image": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot-mobile.gif`,
            "content" : [
                {
                    "content_heading" : "Shoot Like a Pro",
                    "content_subheading" : "Engage your visitors on your website with immersive visuals",
                    "accordion_item_on_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord1.png`,
                    "accordion_item_off_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord01.png`,
                    "content_description": [
                        {
                            "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                            "text": "Anyone can shoot - No photography experience required!",
                        },
                        {
                            "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                            "text": "Follow AI sensor to click standard footwear images",
                        }, 
                    ]
                },
                {
                    "content_heading" : "Edit images - 100% automatically",
                    "content_subheading" : "Use 500X faster transformative tech to edit your images in bulk",
                    "accordion_item_on_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord2.png`,
                    "accordion_item_off_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord02.png`,
                    "content_description": [
                        {
                            "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                            "text": "Choose from 60+ backgrounds or upload your own        ",
                        },
                        {
                            "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                            "text": "The AI app automatically edits all your images in real time",
                        }, 
                    ]
                },
                {
                    "content_heading" : "Publish Instantly",
                    "content_subheading" : "Publish your images to your dealership website faster than ever  ",
                    "accordion_item_on_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord3.png`,
                    "accordion_item_off_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord03.png`,
                    "content_description": [
                        {
                            "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                            "text": "Download ready-to-use shoe images directly from the app",
                        },
                        {
                            "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                            "text": "Instantly publish images to your website  ",
                        }, 
                    ]
                },
            ]
        },
        "web_section" : {
            "heading" : "Make Your Footwear Images Stand Out With AI Editing Tool",
            "sub_heading" : "",
            "banner_heading" : "Leave a Lasting First Impression On Your Visitors With Studio-grade & Sharp Imagery            ",
            "banner_sub_heading" : "Use our 500x faster AI image editing tool to convert poor footwear backgrounds into professional backgrounds in seconds ",
            "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/web-app.png`,
            "banner_image2" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/web-foot.png`,
            "web_description" : [
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Effortlessly edit hundreds of footwear images instantly",
                },
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Choose from 60+ premium & creative templates",
                },
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Turn inconsistent catalogs into engaging & uniform catalogs in real time",
                }
            ],
            "start_now_link": "https://www.spyne.ai/category/footwear/try"
        },
        "api_section" : {
            "heading" : "Automate, Simplify, and Scale Your Work",
            "sub_heading" : "",
            "banner_heading" : "Use Computer Vision & AI Tech to Bring Efficiency to Your Workflow ",
            "banner_sub_heading" : "Effortlessly automate and streamline your workflow with our APIs and reduce week-long processes to a few minutes. ",
            "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/api.png`,
            "api_description" : [
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Transform your massive catalogs instantly ",
                },
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Save 90% of your time by automating repetitive tasks  ",
                },
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Minimize the operational costs significantly ",
                }
            ],
            "start_now_link": "https://documenter.getpostman.com/view/10990096/TzRX7Qbq"
        },
        "dashboard_section" : {
            "heading" : "One Place To Manage & Measure Your Shoots",
            "sub_heading" : "",
            "banner_heading" : "",
            "banner_sub_heading" : "Single dashboard to track and manage all your shoots in real time and download to publish your images directly to your website. ",
            "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/dashboard.png`,
            "api_description" : [
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Affordable way to create quality 360° Walkarounds in minute",
                },
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Make your videos live faster onto your website instantly",
                },
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Let your shoppers explore your vehicles & help them make informed decisions.",
                }
            ],
            "small_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot-middle.png`,
            "zoomInImages" : [
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/foot-middle.png', //Middle Image of dashboard
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-2.png',
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-3.png', 
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-4.png',
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-5.png',
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-6.png',
            ],
        },
        "templates" : {
            "heading" : "Attract Visitors With Premium Backgrounds     ",
            "sub_heading" : "Choose from free marketplace-compliant backgrounds or use your own",
            "custom_images" :[
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot21.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot1.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot22.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot2.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot23.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot3.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot24.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot4.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot5.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot25.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot6.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot26.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot7.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot27.png`
                },

                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot8.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot28.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot9.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot29.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot10.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot30.png`
                },  
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot11.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot31.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot39.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot12.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot13.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot32.png`
                },

                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot33.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot14.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot34.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot15.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot35.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot16.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot36.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot17.png`
                },
                
                
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot18.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/foot37.png`
                },
            ],
            "start_now_link": "https://www.spyne.ai/category/footwear/try",
        },
        "media_logos_section" : {
            "heading": "You Won't Just Hear it From Us   ",
            "sub-heading": "",
            "enterprises_list": [
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client1.png`, 
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client2.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client4.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client3.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client5.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/yahoo.png`, 
            ]
        },
        "clients_slider" :[
            {
                "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client6.png`,
                "description" : "Spyne is a seamless and impressive solution that has streamlined our vehicle photography and accelerated our time to market. The team at Spyne are hugely supportive and easy to deal with, an amazing product and team!",
            },
            { //Amazon
                "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/amazon.png`,
                "description" : "Spyne.ai has always been a valuable service partner in enabling SMBs in online marketplace. Excellent in handling projects. A big shoutout to Vivek  Vishnoi, Shahab and their team of KAMs for handling all key projects well. Kudos to the whole team!",
            },
            { //Karvi
                "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/karvi.png`,
                "description" : "Amazing tool! The Spyne experience is incredible because it offers professional photographs at the moment. The Spyne service helps us to get images of excellence on our site, being able to publish our products in short terms of time. It's wonderful to work with such a professional and collaborative group of people, always reaching for the best results.",
            },
            { //Flipkart
                "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client5.png`,
                "description" : "Spyne is our strategic partner in helping us scale our image/photo-operations across locations and the AI has definitely helped us across the journey. I'd like to rate Spyne 4 out of 5 for the overall experience with their product and services. ",
            },
           
           
        ]

    },

    "product" : {
        "isSubCategoryExist": false,
        "prod_cat_id" : "cat_Ujt0kuFxY",
        "product_sub_cat_id": "",
        "redirect_url" : "/category/product/try",
        "hero_section" :{
            "heading" : "Give Your Online Website The Images it Deserves",
            "sub_heading" :"Elevate your shopper experience using professional product images that improve conversions by 40%",
            "banner_images" : [`${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/product-hero.gif`]
        },
        "enterprises_section" : {
            "heading": "Trusted By The World's Fastest Growing Companies ",
            "sub-heading": "",
            "enterprises_list": [
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client1.png`, 
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client2.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client3.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client4.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client5.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client6.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-n-bike.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/karvi-client.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client9.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client10.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client11.png`
            ]
        },
        // Mobile App section 
        "app_section" : {
            "heading" : "Uplift Your Product Image Creation AI",
            "sub_heading" : "Our cutting edge SpyneAI app enables online sellers to instantly create high-quality images in the fastest turnaround times - 500X faster",
            "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/mobile-app.png`,
            "side_image": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/product-mobile.gif`,
            "content" : [
                {
                    "content_heading" : "Shoot Like a Pro",
                    "content_subheading" : "Engage your visitors on your website with immersive visuals",
                    "accordion_item_on_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord1.png`,
                    "accordion_item_off_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord01.png`,
                    "content_description": [
                        {
                            "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                            "text": "Anyone can shoot - No photography experience required! ",
                        },
                        {
                            "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                            "text": "Follow AI sensor to click standard product images               ",
                        }, 
                    ]
                },
                {
                    "content_heading" : "Edit images - 100% automatically       ",
                    "content_subheading" : "Use 500X faster transformative tech to edit your images in bulk",
                    "accordion_item_on_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord2.png`,
                    "accordion_item_off_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord02.png`,
                    "content_description": [
                        {
                            "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                            "text": "Choose from 60+ backgrounds or upload your own  ",
                        },
                        {
                            "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                            "text": "The AI app automatically edits all your images in realtime",
                        }, 
                    ]
                },
                {
                    "content_heading" : "Publish Instantly",
                    "content_subheading" : "Publish your images to your dealership website faster than ever  ",
                    "accordion_item_on_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord3.png`,
                    "accordion_item_off_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord03.png`,
                    "content_description": [
                        {
                            "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                            "text": "Download marketplace-ready product images directly from the app ",
                        },
                        {
                            "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
                            "text": "Instantly publish images to your website ",
                        }, 
                    ]
                },
            ]
        },
        "web_section" : {
            "heading" : "Create Marketplace-ready Images With AI — 500x Faster",
            "sub_heading" : "",
            "banner_heading" : " ",
            "banner_sub_heading" : "We help you create ready-to-use product photos for your business that boost conversions by 40% using the power of AI",
            "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/web-app.png`,
            "banner_image2" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/web-product.png`,
            "web_description" : [
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Effortlessly edit hundreds of product images instantly",
                },
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Choose marketplace compliant backgrounds ",
                },
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Transform your catalogs to engaging & uniform catalogs in real time",
                }
            ],
            "start_now_link": "https://www.spyne.ai/category/product/try"
        },
        "api_section" : {
            "heading" : "Automate, Simplify & Scale Your Work ",
            "sub_heading" : "",
            "banner_heading" : "Use Computer Vision & AI Tech to Bring Efficiency to Your Workflow     ",
            "banner_sub_heading" : "Effortlessly automate and streamline your workflow with our APIs and reduce week-long processes to a few minutes. ",
            "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/api.png`,
            "api_description" : [
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Transform your massive catalogs instantly ",
                },
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Save 90% of your time by automating repetitive tasks  ",
                },
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Minimize the operational costs significantly ",
                }
            ],
            "start_now_link": "https://documenter.getpostman.com/view/10990096/TzRX7Qbq"
        },
        "dashboard_section" : {
            "heading" : "One Place To Manage & Measure Your Shoots",
            "sub_heading" : "",
            "banner_heading" : "",
            "banner_sub_heading" : "Single dashboard to track and manage all your shoots in real time and download to publish your images directly to your website. ",
            "banner_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/dashboard.png`,
            "api_description" : [
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Affordable way to create quality 360° Walkarounds in minute",
                },
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Make your videos live faster onto your website instantly",
                },
                {
                    "bullet_img": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
                    "text": "Let your shoppers explore your vehicles & help them make informed decisions.",
                }
            ],
            "small_image" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/product-middle.png`,
            "zoomInImages" : [
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/product-middle.png', //Middle Image of dashboard
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-2.png',
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-3.png', 
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-4.png',
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-5.png',
                'https://storage.googleapis.com/spyne-website/SpyneHome-v2/add-6.png',
            ],
        },
        "templates" : {
            "heading" : "Premium Backgrounds For Premium Aesthetics",
            "sub_heading" : "Choose from hundreds of free yet stunning food backgrounds and templates",
            "custom_images" :[
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro21.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro1.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro2.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro22.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro23.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro3.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro4.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro24.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro25.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro5.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro6.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro26.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro7.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro27.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro28.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro8.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro9.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro29.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro30.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro10.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro11.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro31.png`
                },
                
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro33.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro13.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro12.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro32.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro40.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro19.png`
                },
                
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro15.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro35.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro36.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro16.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro17.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro37.png`
                },
                {
                    "before": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro39.png`,
                    "after": `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/pro18.png`
                },

            ],
            "start_now_link": "https://www.spyne.ai/category/product/try",
        },
        "media_logos_section" : {
            "heading": "You Won't Just Hear it From Us   ",
            "sub-heading": "",
            "enterprises_list": [
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client1.png`, 
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client2.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client4.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client3.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/client5.png`,
                `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/Spyne.aiMain/yahoo.png`, 
            ]
        },
        "clients_slider" :[
            {
                "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client6.png`,
                "description" : "Spyne is a seamless and impressive solution that has streamlined our vehicle photography and accelerated our time to market. The team at Spyne are hugely supportive and easy to deal with, an amazing product and team!",
            },
            { //Amazon
                "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/amazon.png`,
                "description" : "Spyne.ai has always been a valuable service partner in enabling SMBs in online marketplace. Excellent in handling projects. A big shoutout to Vivek  Vishnoi, Shahab and their team of KAMs for handling all key projects well. Kudos to the whole team!",
            },
            { //Karvi
                "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/karvi.png`,
                "description" : "Amazing tool! The Spyne experience is incredible because it offers professional photographs at the moment. The Spyne service helps us to get images of excellence on our site, being able to publish our products in short terms of time. It's wonderful to work with such a professional and collaborative group of people, always reaching for the best results.",
            },
            { //Flipkart
                "company_logo" : `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client5.png`,
                "description" : "Spyne is our strategic partner in helping us scale our image/photo-operations across locations and the AI has definitely helped us across the journey. I'd like to rate Spyne 4 out of 5 for the overall experience with their product and services. ",
            },
           
           
        ]

    },


}